import React, { Component } from 'react';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import withAnalyticsEvents, { type WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import { type AnalyticsAttributes } from '@atlassian/analytics-bridge';

import fireErrorAnalytics from './fire-error-analytics';

// it's a workaround since React doesn't provide native types for this
interface ErrorInfo {
	componentStack: string;
}

interface Props {
	attributes?: AnalyticsAttributes;
	children: React.ReactNode;
	// this prop is coming from Atlaskit, can't rename it
	createAnalyticsEvent: CreateUIAnalyticsEvent;
	id: string;
	packageName: string;
}

interface State {
	analyticsEvent: UIAnalyticsEvent | null;
}

class CatchAndReportErrors extends Component<Props, State> {
	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		const { packageName, id, attributes, createAnalyticsEvent } = this.props;
		const analyticsEvent = createAnalyticsEvent({ action: 'failed' });
		fireErrorAnalytics({
			event: analyticsEvent,
			errorInfo,
			error,
			meta: {
				id,
				packageName,
			},
			attributes,
		});

		throw error;
	}

	render() {
		const { children } = this.props;

		return <>{children}</>;
	}
}

const reportingErrorBoundary: React.ForwardRefExoticComponent<
	Omit<Props, keyof WithAnalyticsEventsProps> & React.RefAttributes<any>
> = withAnalyticsEvents()(CatchAndReportErrors);
export default reportingErrorBoundary;
